import { useLingui } from '@lingui/react/macro'
import { notifications } from '@mantine/notifications'
import { trpc } from '../trpc'

export const billingHooks = {
  useGetBillingPortalUrl: () => {
    const { t } = useLingui()
    return trpc.billing.getBillingPortalUrl.useMutation({
      onSuccess: (data) => {
        window.location.href = data.url
      },
      onError: (error) => {
        notifications.show({
          title: t`Error`,
          message: error.message || t`Failed to open billing portal`,
          color: 'red',
        })
      },
    })
  },

  useCreateCheckoutSession: () => {
    const { t } = useLingui()
    return trpc.billing.createCheckoutSession.useMutation({
      onSuccess: (data) => {
        if (data.url) {
          window.location.href = data.url
        }
      },
      onError: (error) => {
        notifications.show({
          title: t`Error`,
          message: error.message || t`Failed to create payment session`,
          color: 'red',
        })
      },
    })
  },

  useAcceptOfferCheckout: () => {
    const { t } = useLingui()
    return trpc.billing.acceptOfferCheckout.useMutation({
      onSuccess: (data) => {
        if (data.url) {
          window.location.href = data.url
        }
      },
      onError: (error) => {
        notifications.show({
          title: t`Error`,
          message: error.message || t`Failed to accept offer`,
          color: 'red',
        })
      },
    })
  },
}
